"use client";

import { getCexLabel } from "@cede/utils";
import { ExchangeIcon } from "@/components/icons";
import { usePrioritizedItems, useHubUser } from "@/hooks";

interface LinkExchangesGridProps {
  exchangeIds: string[];
  handleSelectCex: (exchangeId: string) => void;
}

export const LinkExchangesGrid = ({ exchangeIds, handleSelectCex }: LinkExchangesGridProps) => {
  const { userExchanges } = useHubUser();

  const alreadyAddedExchangeIds = Object.keys(userExchanges);

  const prioritizedExchangeIds = usePrioritizedItems(exchangeIds, alreadyAddedExchangeIds);

  return (
    <div className="grid grid-cols-3 gap-[30px] justify-center">
      {prioritizedExchangeIds.map((exchangeId) => {
        const isConnected = alreadyAddedExchangeIds.includes(exchangeId);

        return (
          <button
            type="button"
            key={exchangeId}
            className="border-0 flex flex-col items-center p-2.5 rounded-medium hover:bg-cede-primary-dark/10 transition-colors cursor-pointer"
            onClick={() => {
              if (!isConnected) {
                handleSelectCex(exchangeId);
              }
            }}
          >
            <div className="flex flex-col items-center px-2.5 pb-2.5 rounded-small">
              <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-cede-bg-component">
                <ExchangeIcon exchange={exchangeId} size={32} />
              </div>
            </div>
            <div className="flex flex-col w-full items-center">
              <span className="text-badge text-cede-text-primary">{getCexLabel(exchangeId)}</span>
              {isConnected && <span className="text-badge text-cede-primary font-semibold">Connected</span>}
            </div>
          </button>
        );
      })}
    </div>
  );
};
